// removed by extract-text-webpack-plugin


// WEBPACK FOOTER //
// ./node_modules/extract-text-webpack-plugin/dist/"}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-685a7e11","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/register/index.vue